var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chi-form-section left" }, [
    _c("div", { staticClass: "branding-container" }, [
      _vm._m(0),
      _c("h1", [_vm._v("Good " + _vm._s(_vm.time_of_day) + "!")]),
      _vm._m(1),
      _c("p", [
        _vm._v(
          "Please note that the sched­uled main­te­nance win­dow for CCC ap­pli­ca­tions is on Sun­day from 5:00–9:00am Cen­tral Time. Dur­ing this time CCC can­not guar­an­tee the avail­abil­i­ty of ap­pli­ca­tions."
        )
      ])
    ]),
    _vm._m(2)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "picture-frame" }, [
      _c("img", {
        attrs: {
          src: "images/ccc-temp-logo.png",
          alt:
            "The Custom Computing Corporation icon. It is a pair of curved arcs on a square blue background."
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "Thank you for choos­ing Cus­tom Com­put­ing as your so­lu­tions part­ner. If you have any ques­tions or need as­sis­tance, please feel free to con­tact us at "
      ),
      _c("a", { attrs: { href: "tel:+18002791222" } }, [
        _vm._v("1.800.279.1222")
      ]),
      _vm._v(". For re­cent up­dates to our app­li­ca­tions, please re­view "),
      _c(
        "a",
        {
          attrs: {
            href:
              "https://knowledgebase.ccc-webservices.com/?ht_kb=august-2021-release-notes",
            target: "_blank"
          }
        },
        [_vm._v("the re­lease notes")]
      ),
      _vm._v(" on the CCC Know­ledge Base.")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cpt-wrapper" }, [
      _c("div", { staticClass: "cpt-container" }, [
        _c("p", [_vm._v("Notices & Disclaimer")]),
        _c("p", [
          _vm._v("CPT"),
          _c("sup", [_vm._v("®")]),
          _vm._v(
            "copy­right 2019 Amer­i­can Med­ical As­so­ci­a­tion. All rights re­served."
          )
        ]),
        _c("p", [
          _vm._v(
            "Fee sched­ules, rel­a­tive val­ue units, con­ver­sion fac­tors and/or re­lat­ed com­po­nents are not as­signed by the AMA, are not part of CPT, and the AMA is not rec­om­mend­ing their use. The AMA does not di­rect­ly or in­di­rect­ly prac­tice med­i­cine or dis­pense med­ical ser­vices. The AMA as­sumes no li­a­bil­i­ty for da­ta con­tained or not con­tained here­in. herein."
          )
        ]),
        _c("p", [
          _vm._v(
            "CPT is a reg­is­tered trade­mark of the Amer­i­can Med­ical As­so­ci­a­tion."
          )
        ])
      ]),
      _c("div", { staticClass: "cpt-container right" }, [
        _c("p", [_vm._v("U.S. Gov­ern­ment Rights")]),
        _c("p", [
          _vm._v(
            "This prod­uct in­cludes CPT which is com­mer­cial tech­ni­cal da­ta, which was de­vel­oped ex­clu­sive­ly at pri­vate ex­pense by the Amer­i­can Med­ical As­so­ci­a­tion (AMA), 330 North Wabash Av­enue, Chica­go, Illi­nois 60611. The AMA does not agree to li­cense CPT to the Fed­er­al Gov­ern­ment based on the li­cense in FAR 52.227­14 (Da­ta Rights - Gen­er­al) and DFARS 252.227–7015 (Tech­ni­cal Da­ta - Com­mer­cial Items) or any oth­er li­cense pro­vi­sion. The AMA re­serves all rights to ap­prove any li­cense with any Fed­er­al agency."
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }